import { EventStream, SEED_CLUSTERS, NeuralClassifier, TrainingSet, loadModel, loadTrainingSet, saveLabelCorpus, saveModel, saveTrainingSet, dspConfig, dspFingerprint, qualifiedLabel, localizeImpulses, pickBurstFrames, gateAndClassify, PopOnsetGate, arrayToFeatureVector, } from "@beatbox/voice-core";
import { markPhonemeTrained } from "../storage/phonemes.js";
import { getActiveLibraryId, refreshTrainedFlags, } from "../storage/libraries.js";
const ZERO = {
    centroid: 0,
    noise: 0,
    voicing: 0,
    energy: 0,
    transient: 0,
    flatness: 0,
    rolloff: 0,
    tilt: 0,
    pitchHz: 0,
    pitchConf: 0,
    pitchClass: -1,
    spread: 0,
    crest: 0,
    flux: 0,
    zcr: 0,
    hnr: 0,
};
export class Diagnostics {
    constructor(d) {
        Object.defineProperty(this, "d", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: d
        });
        Object.defineProperty(this, "raf", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "running", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "stream", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "popGate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new PopOnsetGate()
        });
        Object.defineProperty(this, "level", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "eventCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "lastTs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "lastEventLog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "lastCluster", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "holdMs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "hits", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "lastHitAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "capture", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "captureTimes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "captureId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "captureStart", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "captureEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "captureDurationMs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "tuned", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, "finishing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "trainingSet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new TrainingSet()
        });
        Object.defineProperty(this, "classifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new NeuralClassifier()
        });
        Object.defineProperty(this, "training", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "classifierReady", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "autoRetrain", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "trainDataCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "trainDataDirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "negativeFrames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "corpusDspFingerprint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "pendingLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "pendingFrames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "recentFrames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "lastPopTapAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: -Infinity
        });
        Object.defineProperty(this, "counterId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "multiTapId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "multiTapExpected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "multiTapFrames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "popPanelId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "popPanelPositives", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "gainPanelActive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "pitchInvariantLabels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, "tick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (!this.running)
                    return;
                const now = typeof performance !== "undefined" ? performance.now() : 0;
                const dtMs = this.lastTs ? now - this.lastTs : 16;
                this.lastTs = now;
                const events = this.stream.drain();
                let latest = null;
                for (const ev of events) {
                    latest = ev;
                    this.eventCount += 1;
                    if (this.capture) {
                        this.capture.push(ev.features);
                        this.captureTimes.push(now);
                    }
                    else if (this.multiTapId) {
                        this.multiTapFrames.push({ t: now, f: ev.features });
                    }
                    else if (this.counterId) {
                        this.negativeFrames.push(ev.features);
                        if (this.negativeFrames.length > 480)
                            this.negativeFrames.shift();
                    }
                    else {
                        if ((ev.features.energy ?? 0) < dspConfig.energyGate) {
                            this.negativeFrames.push(ev.features);
                            if (this.negativeFrames.length > 240) {
                                this.negativeFrames.shift();
                            }
                        }
                    }
                    this.recentFrames.push({ t: now, f: ev.features });
                    const cutoff = now - 2000;
                    while (this.recentFrames.length > 0 && this.recentFrames[0].t < cutoff) {
                        this.recentFrames.shift();
                    }
                }
                if (now - this.lastEventLog > 1000) {
                    this.lastEventLog = now;
                    console.info(`[Diagnostics] heartbeat events(session)=${this.eventCount} ` +
                        `drainedThisSec=${events.length} ` +
                        `latestCluster=${latest?.clusterId ?? "none"} ` +
                        `latestEnergy=${(latest?.features.energy ?? 0).toFixed(3)} ` +
                        `level=${this.level.toFixed(3)}`);
                }
                const features = latest ? latest.features : ZERO;
                let clusterId = latest ? latest.clusterId : this.lastCluster;
                let confidence = latest ? latest.confidence : 0;
                let precision = latest ? latest.delta.precision : 0;
                if (latest && this.classifierReady && this.classifier.ready) {
                    const gated = gateAndClassify(latest.features, this.classifier);
                    clusterId = gated.clusterId;
                    confidence = gated.confidence;
                    precision = gated.delta.precision;
                }
                if (clusterId === "pop") {
                    const energy = latest ? (latest.features.energy ?? 0) : 0;
                    const transient = latest ? (latest.features.transient ?? 0) : 0;
                    const sinceLast = this.popGate.accept(energy, transient, now);
                    if (sinceLast === null) {
                        clusterId = null;
                        confidence = 0;
                        precision = 0;
                    }
                    else {
                        console.debug(`[Diagnostics] POP onset accepted #${this.popGate.count} ` +
                            `(${Number.isFinite(sinceLast) ? sinceLast.toFixed(0) : "∞"}ms ` +
                            `since last) energy=${energy.toFixed(3)} ` +
                            `transient=${transient.toFixed(3)}`);
                    }
                }
                const target = latest ? latest.features.energy : 0;
                this.level = this.level * 0.8 + target * 0.2;
                if (clusterId) {
                    this.holdMs[clusterId] = (this.holdMs[clusterId] ?? 0) + dtMs;
                    const last = this.lastHitAt[clusterId] ?? -Infinity;
                    if (clusterId !== this.lastCluster || now - last > 180) {
                        this.hits[clusterId] = (this.hits[clusterId] ?? 0) + 1;
                        this.lastHitAt[clusterId] = now;
                    }
                    this.lastCluster = clusterId;
                }
                let calibrateProgress = 0;
                if (this.capture) {
                    const elapsed = now - this.captureStart;
                    calibrateProgress = Math.max(0, Math.min(1, elapsed / this.captureDurationMs));
                    if (Number.isFinite(this.captureDurationMs) &&
                        elapsed >= this.captureDurationMs) {
                        void this.finishCalibration();
                        calibrateProgress = 1;
                    }
                }
                if (this.trainDataDirty || this.trainDataCache === null) {
                    this.trainDataCache = this.trainingSet.toJSON();
                    this.trainDataDirty = false;
                }
                this.d.onSnapshot({
                    features,
                    clusterId,
                    confidence,
                    precision,
                    level: Math.max(0, Math.min(1, this.level)),
                    eventCount: this.eventCount,
                    holdMs: { ...this.holdMs },
                    hits: { ...this.hits },
                    calibrating: this.capture !== null,
                    calibratingId: this.captureId,
                    calibrateProgress,
                    tunedIds: [...this.tuned],
                    counteringId: this.counterId,
                    multiTapId: this.multiTapId,
                    multiTapFrameCount: this.multiTapFrames.length,
                    trainCounts: Object.fromEntries(this.trainingSet
                        .labels()
                        .map((l) => [l, this.trainingSet.countFor(l)])),
                    trainData: this.trainDataCache ?? undefined,
                    training: this.training,
                });
                this.raf = requestAnimationFrame(this.tick);
            }
        });
        this.stream = new EventStream(d.engine);
    }
    start() {
        console.info("[Diagnostics] start");
        this.d.engine.reset();
        this.d.engine.setClusters(SEED_CLUSTERS);
        void this.loadPersistedModel();
        this.d.engine.setCalibrating(false);
        this.d.engine.setConfig({
            frameHopMs: dspConfig.frameHopMs,
            energyGate: dspConfig.energyGate,
            energyScale: dspConfig.energyScale,
            noiseBandLoHz: dspConfig.noiseBandLoHz,
            noiseBandHiHz: dspConfig.noiseBandHiHz,
            voicingBandHiHz: dspConfig.voicingBandHiHz,
            transientScale: dspConfig.transientScale,
        });
        this.running = true;
        this.lastTs = typeof performance !== "undefined" ? performance.now() : 0;
        this.tick();
    }
    stop() {
        if (this.running)
            console.info("[Diagnostics] stop");
        this.running = false;
        cancelAnimationFrame(this.raf);
    }
    dispose() {
        console.info("[Diagnostics] dispose");
        this.stop();
        this.stream.dispose();
    }
    setAutoRetrain(on) {
        console.info(`[Diagnostics] auto-retrain ${on ? "enabled" : "disabled"}`);
        this.autoRetrain = on;
    }
    setPitchInvariantLabels(labels) {
        this.pitchInvariantLabels = new Set(labels);
        this.classifier.setPitchInvariantLabels(this.pitchInvariantLabels);
        console.info("[Diagnostics] pitch-invariant labels updated: " +
            `[${[...this.pitchInvariantLabels].join(",") || "none"}]`);
    }
    setImpulseLabels(labels) {
        const impulseLabels = [...new Set(labels)];
        this.classifier.configure({ impulseLabels });
        console.info("[Diagnostics] impulse labels auto-inferred: " +
            `[${impulseLabels.join(",") || "none"}]`);
    }
    configureClassifier(patch) {
        this.classifier.configure(patch);
        console.info("[Diagnostics] classifier reconfigured", patch);
    }
    setFrameHopMs(ms) {
        console.info(`[Diagnostics] analysis packet duration set to ${ms}ms`);
        this.d.engine.setConfig({ frameHopMs: ms });
    }
    pushDspConfig() {
        this.d.engine.setConfig({
            frameHopMs: dspConfig.frameHopMs,
            energyGate: dspConfig.energyGate,
            energyScale: dspConfig.energyScale,
            noiseBandLoHz: dspConfig.noiseBandLoHz,
            noiseBandHiHz: dspConfig.noiseBandHiHz,
            voicingBandHiHz: dspConfig.voicingBandHiHz,
            transientScale: dspConfig.transientScale,
        });
    }
    isClassifierActive() {
        return this.classifierReady && this.classifier.ready;
    }
    async retrainNow() {
        console.info("[Diagnostics] explicit retrain requested");
        await this.retrain();
    }
    clearAllTrainingData() {
        console.info("[Diagnostics] clearing ALL training data");
        this.trainingSet.clearAll();
        this.tuned.clear();
        this.pendingLabel = null;
        this.pendingFrames = [];
        this.negativeFrames = [];
        this.trainDataDirty = true;
        void this.persistCorpus();
    }
    /**
     * Completely wipe all calibration state: in-memory training set, the
     * persisted model + corpus, and every per-label corpus for the active
     * library. Used by "start fresh" in Setup.
     */
    async clearEverything() {
        console.info("[Diagnostics] clearing EVERYTHING (fresh start)");
        this.trainingSet.clearAll();
        this.tuned.clear();
        this.pendingLabel = null;
        this.pendingFrames = [];
        this.negativeFrames = [];
        this.trainDataDirty = true;
        this.classifierReady = false;
        this.corpusDspFingerprint = null;
        this.d.engine.setClassifier(null);
        try {
            await saveModel({
                version: 1,
                labels: [],
                featureNames: [],
                modelTopology: null,
                weightSpecs: null,
                weightDataB64: "",
            });
            await saveTrainingSet({}, this.dspFingerprint());
            const { getActiveLibraryId, refreshTrainedFlags } = await import("../storage/libraries.js");
            const { clearLabelCorpus } = await import("../storage/model.js");
            const { qualifiedLabel } = await import("../storage/qualified.js");
            const libraryId = await getActiveLibraryId();
            const { getLibrary } = await import("../storage/libraries.js");
            const lib = await getLibrary(libraryId);
            for (const p of lib?.phonemes ?? []) {
                await clearLabelCorpus(qualifiedLabel(libraryId, p.id));
            }
            await clearLabelCorpus(qualifiedLabel(libraryId, "silence"));
            await refreshTrainedFlags(libraryId);
        }
        catch (err) {
            console.warn("[Diagnostics] failed to fully clear calibration", err);
        }
    }
    clearTrainingLabel(label) {
        console.info(`[Diagnostics] clearing training data for '${label}'`);
        this.trainingSet.clearLabel(label);
        this.tuned.delete(label);
        if (this.pendingLabel === label) {
            this.pendingLabel = null;
            this.pendingFrames = [];
        }
        this.trainDataDirty = true;
        void this.persistCorpus();
    }
    calibrate(clusterId, durationMs = 2200) {
        if (this.capture) {
            console.warn("[Diagnostics] calibration already in progress; ignoring");
            return;
        }
        console.info(`[Diagnostics] calibration START '${clusterId}' ` +
            `durationMs=${durationMs}`);
        this.capture = [];
        this.captureId = clusterId;
        this.captureStart =
            typeof performance !== "undefined" ? performance.now() : 0;
        this.captureDurationMs = durationMs;
        this.captureTimes = [];
    }
    startCalibrateHold(clusterId) {
        if (this.capture) {
            console.warn("[Diagnostics] calibration already in progress; ignoring");
            return;
        }
        console.info(`[Diagnostics] calibration HOLD START '${clusterId}'`);
        this.capture = [];
        this.captureId = clusterId;
        this.captureStart =
            typeof performance !== "undefined" ? performance.now() : 0;
        this.captureDurationMs = Infinity;
        this.captureTimes = [];
        this.captureEnd = 0;
    }
    endCalibrateHold() {
        if (!this.capture)
            return;
        this.captureEnd =
            typeof performance !== "undefined" ? performance.now() : 0;
        console.info(`[Diagnostics] calibration HOLD END '${this.captureId}' ` +
            `frames=${this.capture.length}`);
        void this.finishCalibration();
    }
    startCounterHold(clusterId) {
        if (this.capture) {
            console.warn("[Diagnostics] calibration in progress; ignoring counter-hold");
            return;
        }
        if (this.counterId)
            return;
        console.info(`[Diagnostics] counter-calibration HOLD START '${clusterId}'`);
        this.counterId = clusterId;
    }
    endCounterHold() {
        if (!this.counterId)
            return;
        const id = this.counterId;
        this.counterId = null;
        console.info(`[Diagnostics] counter-calibration HOLD END '${id}' ` +
            `negatives=${this.negativeFrames.length}`);
        if (this.negativeFrames.length > 0) {
            const budget = Math.min(this.negativeFrames.length, 60);
            this.trainingSet.addMany("silence", this.negativeFrames.slice(-budget));
            this.trainDataDirty = true;
            console.info(`[Diagnostics] counter-hold committed ${budget} negative ` +
                `frame(s) as 'silence'`);
            if (this.autoRetrain) {
                void this.retrain();
            }
            else {
                void this.persistCorpus();
            }
        }
    }
    tapCalibrate(clusterId) {
        if (this.capture) {
            console.warn("[Diagnostics] calibration already in progress; ignoring tap");
            return;
        }
        const now = typeof performance !== "undefined" ? performance.now() : 0;
        const POS_WINDOW_MS = 250;
        const sinceLastTap = now - this.lastPopTapAt;
        const negSpanMs = Math.min(1000, Math.max(0, sinceLastTap));
        const posLo = now - POS_WINDOW_MS;
        const negLo = now - POS_WINDOW_MS - negSpanMs;
        const positives = [];
        for (const rec of this.recentFrames) {
            if (rec.t >= posLo) {
                positives.push(rec.f);
            }
            else if (rec.t >= negLo && rec.t < posLo) {
                this.negativeFrames.push(rec.f);
                if (this.negativeFrames.length > 240)
                    this.negativeFrames.shift();
            }
        }
        this.lastPopTapAt = now;
        console.info(`[Diagnostics] TAP calibrate '${clusterId}' ` +
            `positives=${positives.length} negWindowMs=${negSpanMs | 0} ` +
            `sinceLastTap=${Number.isFinite(sinceLastTap) ? sinceLastTap | 0 : "∞"}`);
        if (positives.length === 0) {
            console.warn(`[Diagnostics] tap '${clusterId}' captured 0 frames — ` +
                `make the sound AS you click`);
            return;
        }
        void this.applyTapCalibration(clusterId, positives);
    }
    startMultiTapCapture(clusterId, expectedCount) {
        if (this.capture || this.multiTapId) {
            console.warn("[Diagnostics] capture already in progress; ignoring multi-tap");
            return;
        }
        console.info(`[Diagnostics] multi-tap capture START '${clusterId}' ` +
            `expecting ${expectedCount} taps`);
        this.multiTapId = clusterId;
        this.multiTapExpected = Math.max(1, expectedCount);
        this.multiTapFrames = [];
    }
    async endMultiTapCapture() {
        if (!this.multiTapId)
            return;
        const id = this.multiTapId;
        const expected = this.multiTapExpected;
        const recording = this.multiTapFrames;
        this.multiTapId = null;
        this.multiTapExpected = 0;
        this.multiTapFrames = [];
        console.info(`[Diagnostics] multi-tap capture END '${id}' ` +
            `frames=${recording.length} expected=${expected}`);
        const impulses = localizeImpulses(recording, expected);
        if (impulses.length < expected) {
            console.warn(`[Diagnostics] multi-tap '${id}' found ${impulses.length}/` +
                `${expected} onsets — some taps may have been too quiet. ` +
                `Using what was found; re-prompt for a cleaner take if needed.`);
        }
        const positives = [];
        const onsetTimes = new Set();
        for (const imp of impulses) {
            positives.push(...imp.frames);
            onsetTimes.add(imp.tMs);
        }
        if (positives.length === 0) {
            console.warn(`[Diagnostics] multi-tap '${id}' localized 0 onsets — ` +
                `ensure taps are distinct and above ambient`);
            return;
        }
        const NEAR_MS = 80;
        const onsetTimeArr = [...onsetTimes];
        for (const rec of recording) {
            const nearOnset = onsetTimeArr.some((t) => Math.abs(rec.t - t) <= NEAR_MS);
            if (!nearOnset) {
                this.negativeFrames.push(rec.f);
                if (this.negativeFrames.length > 480)
                    this.negativeFrames.shift();
            }
        }
        await this.applyTapCalibration(id, positives);
    }
    startPopPanel(clusterId) {
        if (this.capture || this.multiTapId || this.popPanelId) {
            console.warn("[Diagnostics] capture already in progress; ignoring pop-panel");
            return;
        }
        console.info(`[Diagnostics] pop-panel START '${clusterId}'`);
        this.popPanelId = clusterId;
        this.popPanelPositives = [];
    }
    isPopPanelActive() {
        return this.popPanelId !== null;
    }
    popPanelCommit(outcome, frames) {
        if (!this.popPanelId)
            return;
        if (frames.length === 0)
            return;
        if (outcome === "sample") {
            const burst = pickBurstFrames(frames);
            // Keep at least a couple of frames per pop even if the burst
            // selector is aggressive, so percussive corpora reach the trained
            // threshold reliably.
            const kept = burst.length > 0 ? burst : frames.slice(0, 2);
            this.popPanelPositives.push(...kept);
            console.info(`[Diagnostics] pop-panel SAMPLE '${this.popPanelId}' ` +
                `+${kept.length} burst frame(s) ` +
                `(total=${this.popPanelPositives.length})`);
        }
        else {
            for (const f of frames) {
                this.negativeFrames.push(f);
                if (this.negativeFrames.length > 480)
                    this.negativeFrames.shift();
            }
            console.info(`[Diagnostics] pop-panel ${outcome.toUpperCase()} ` +
                `'${this.popPanelId}' +${frames.length} negative frame(s)`);
        }
    }
    cancelPopPanel() {
        if (!this.popPanelId)
            return;
        console.info(`[Diagnostics] pop-panel CANCEL '${this.popPanelId}'`);
        this.popPanelId = null;
        this.popPanelPositives = [];
    }
    startGainPanel() {
        if (this.gainPanelActive)
            return;
        console.info("[Diagnostics] gain-panel START");
        this.gainPanelActive = true;
    }
    /**
     * Record a dedicated block of silence/ambient frames and commit them to the
     * 'silence' training label. Used by the quick-setup silence step to ensure
     * the classifier has a strong negative/reject class.
     */
    async recordSilence(durationMs) {
        console.info(`[Diagnostics] dedicated silence capture START ` +
            `durationMs=${durationMs}`);
        const start = typeof performance !== "undefined" ? performance.now() : Date.now();
        const before = this.recentFrames.length;
        void before;
        await new Promise((resolve) => {
            const check = () => {
                const now = typeof performance !== "undefined" ? performance.now() : Date.now();
                if (now - start >= durationMs)
                    resolve();
                else
                    setTimeout(check, 100);
            };
            check();
        });
        const cutoff = start;
        const frames = this.recentFrames
            .filter((r) => r.t >= cutoff)
            .map((r) => r.f);
        if (frames.length === 0) {
            console.warn("[Diagnostics] dedicated silence capture collected 0 frames");
            return 0;
        }
        const budget = Math.min(frames.length, 240);
        this.trainingSet.addMany("silence", frames.slice(-budget));
        this.trainDataDirty = true;
        void markPhonemeTrained("silence");
        console.info(`[Diagnostics] dedicated silence capture committed ${budget} ` +
            `frame(s) as 'silence'`);
        if (this.autoRetrain) {
            await this.retrain();
        }
        else {
            await this.persistCorpus();
        }
        return budget;
    }
    isGainPanelActive() {
        return this.gainPanelActive;
    }
    endGainPanel() {
        if (!this.gainPanelActive)
            return;
        console.info("[Diagnostics] gain-panel END");
        this.gainPanelActive = false;
        this.pushDspConfig();
    }
    cancelGainPanel() {
        if (!this.gainPanelActive)
            return;
        console.info("[Diagnostics] gain-panel CANCEL");
        this.gainPanelActive = false;
    }
    async endPopPanel() {
        if (!this.popPanelId)
            return;
        const id = this.popPanelId;
        const positives = this.popPanelPositives;
        this.popPanelId = null;
        this.popPanelPositives = [];
        console.info(`[Diagnostics] pop-panel END '${id}' ` + `positives=${positives.length}`);
        if (positives.length === 0) {
            console.warn(`[Diagnostics] pop-panel '${id}' collected 0 in-window ` +
                `plosives — nothing to apply`);
            return;
        }
        await this.applyTapCalibration(id, positives);
    }
    async applyTapCalibration(id, positives) {
        if (positives.length === 0)
            return;
        const negativesSnapshot = this.negativeFrames.slice();
        const burst = pickBurstFrames(positives);
        console.info(`[Diagnostics] tap '${id}' burst-selected ${burst.length}/` +
            `${positives.length} frames (dropping quiet decay/ambient)`);
        this.trainingSet.addMany(id, burst);
        this.pendingLabel = id;
        this.pendingFrames = [...burst];
        this.trainDataDirty = true;
        void markPhonemeTrained(id);
        const popCount = this.trainingSet.countFor(id);
        const silCount = this.trainingSet.countFor("silence");
        if (negativesSnapshot.length > 0 && silCount < popCount * 3 + 20) {
            const negBudget = Math.min(burst.length * 2, 12);
            this.trainingSet.addMany("silence", negativesSnapshot.slice(-negBudget));
        }
        else {
            console.info(`[Diagnostics] skipping tap negatives (silence=${silCount} ` +
                `>> pop=${popCount}); corpus already silence-heavy`);
        }
        this.tuned.add(id);
        console.info(`[Diagnostics] tap frames added '${id}' ` +
            `(+${burst.length}) — retraining`);
        if (this.autoRetrain) {
            await this.retrain();
        }
        else {
            console.info("[Diagnostics] auto-retrain off; corpus persisted only");
            await this.persistCorpus();
        }
    }
    async retrain() {
        const fp = this.dspFingerprint();
        if (this.corpusDspFingerprint && this.corpusDspFingerprint !== fp) {
            console.warn("[Diagnostics] DSP config changed since earlier captures " +
                `(was ${this.corpusDspFingerprint}, now ${fp}). Feature ` +
                "vectors are extraction-config dependent, so mixing them " +
                "produces an unreliable model. PURGING all previously " +
                "captured labels so only frames from the CURRENT config " +
                "remain. Recapture any sounds you still want.");
            this.trainingSet.clearAll();
            this.tuned.clear();
            if (this.pendingLabel && this.pendingFrames.length > 0) {
                this.trainingSet.addMany(this.pendingLabel, this.pendingFrames);
                this.tuned.add(this.pendingLabel);
                console.info(`[Diagnostics] re-added ${this.pendingFrames.length} ` +
                    `current-config frames for '${this.pendingLabel}'`);
            }
        }
        this.corpusDspFingerprint = fp;
        this.pendingLabel = null;
        this.pendingFrames = [];
        const labels = this.trainingSet.labels();
        if (labels.length < 2) {
            console.info(`[Diagnostics] need ≥2 labeled sounds to train ` +
                `(have ${labels.length}); capturing more first`);
            await this.persistCorpus();
            return;
        }
        this.training = true;
        try {
            this.classifier.setPitchInvariantLabels(this.pitchInvariantLabels);
            await this.classifier.train(this.trainingSet.toFrames());
            this.d.engine.setClassifier(this.classifier);
            this.classifierReady = this.classifier.ready;
            console.info("[Diagnostics] classifier trained + activated");
            const serialized = await this.classifier.serialize();
            if (serialized)
                await saveModel(serialized);
            await this.persistCorpus();
        }
        catch (err) {
            console.error("[Diagnostics] training failed", err);
        }
        finally {
            this.training = false;
        }
    }
    async persistCorpus() {
        try {
            await saveTrainingSet(this.trainingSet.toJSON(), this.dspFingerprint());
            await this.persistPerLabelCorpora();
        }
        catch (err) {
            console.error("[Diagnostics] failed to persist training set", err);
        }
    }
    async persistPerLabelCorpora() {
        try {
            const libraryId = await getActiveLibraryId();
            const fp = this.dspFingerprint();
            const data = this.trainingSet.toJSON();
            for (const [label, rows] of Object.entries(data)) {
                await saveLabelCorpus(qualifiedLabel(libraryId, label), rows, fp);
            }
            await refreshTrainedFlags(libraryId);
        }
        catch (err) {
            console.warn("[Diagnostics] failed to persist per-label corpora", err);
        }
    }
    dspFingerprint() {
        return dspFingerprint(dspConfig);
    }
    async loadPersistedModel() {
        try {
            const savedCorpus = await loadTrainingSet();
            if (savedCorpus) {
                const liveFp = this.dspFingerprint();
                const savedFp = savedCorpus.dspFingerprint;
                if (savedFp !== null && savedFp !== liveFp) {
                    console.error("[Diagnostics] DISCARDING persisted corpus: it was " +
                        `captured under DSP config '${savedFp}' but we are now ` +
                        `running '${liveFp}'. Feature vectors are extraction-` +
                        "config dependent, so mixing them makes 'silence' " +
                        "uncalibratable and collapses the model to one class " +
                        "(everything reads as 'hum'). Recapture all sounds " +
                        "under the current config.");
                    this.corpusDspFingerprint = liveFp;
                    try {
                        await saveModel({
                            version: 1,
                            labels: [],
                            featureNames: [],
                            modelTopology: null,
                            weightSpecs: null,
                            weightDataB64: "",
                        });
                        console.warn("[Diagnostics] cleared stale on-disk model " +
                            "(config mismatch); recapture sounds to retrain");
                    }
                    catch (err) {
                        console.warn("[Diagnostics] failed to clear stale model", err);
                    }
                    return;
                }
                const ts = TrainingSet.fromJSON(savedCorpus.data);
                for (const label of ts.labels())
                    this.tuned.add(label);
                for (const { label, features } of ts.toFrames()) {
                    this.trainingSet.add(label, arrayToFeatureVector(features));
                }
                this.trainDataDirty = true;
                this.corpusDspFingerprint = savedFp ?? liveFp;
                console.info("[Diagnostics] rehydrated persisted corpus under matching " +
                    `DSP fingerprint '${liveFp}'`);
            }
            const savedModel = await loadModel();
            if (savedModel &&
                savedModel.labels.length >= 2 &&
                savedModel.weightDataB64) {
                await this.classifier.load(savedModel);
                for (const l of savedModel.labels)
                    this.tuned.add(l);
                this.d.engine.setClassifier(this.classifier);
                this.classifierReady = this.classifier.ready;
                console.info("[Diagnostics] applied persisted trained model " +
                    `(labels: ${savedModel.labels.join(",") || "none"})`);
            }
            else if (savedModel) {
                console.info("[Diagnostics] skipping persisted model (empty/sentinel " +
                    `labels=${savedModel.labels.length})`);
            }
            if (!this.classifierReady && this.trainingSet.labels().length >= 2) {
                console.info("[Diagnostics] no usable persisted model; auto-training " +
                    "from persisted corpus on load");
                await this.retrain();
            }
        }
        catch (err) {
            console.warn("[Diagnostics] failed to load model", err);
        }
    }
    async finishCalibration() {
        if (this.finishing)
            return;
        this.finishing = true;
        try {
            const id = this.captureId;
            const frames = this.capture ?? [];
            const times = this.captureTimes;
            this.capture = null;
            this.captureTimes = [];
            this.captureId = null;
            if (!id) {
                return;
            }
            console.info(`[Diagnostics] calibration CAPTURED '${id}' frames=${frames.length}`);
            const PAD_MS = 100;
            const lo = (times.length > 0 ? times[0] : this.captureStart) + PAD_MS;
            const hiEdge = this.captureEnd > 0
                ? this.captureEnd
                : times.length > 0
                    ? times[times.length - 1]
                    : lo;
            const hi = hiEdge - PAD_MS;
            let kept = frames;
            if (times.length === frames.length && hi > lo) {
                const trimmed = frames.filter((_f, i) => times[i] >= lo && times[i] <= hi);
                if (trimmed.length >= 3) {
                    console.info(`[Diagnostics] calibration '${id}' auto-padded ` +
                        `${frames.length}→${trimmed.length} frames ` +
                        `(dropped ±${PAD_MS}ms around press/release)`);
                    kept = trimmed;
                }
            }
            this.captureEnd = 0;
            this.trainingSet.addMany(id, kept);
            this.pendingLabel = id;
            this.pendingFrames = [...kept];
            this.tuned.add(id);
            this.trainDataDirty = true;
            void markPhonemeTrained(id);
            if (this.autoRetrain) {
                await this.retrain();
            }
            else {
                console.info("[Diagnostics] auto-retrain off; corpus persisted only");
                await this.persistCorpus();
            }
        }
        finally {
            this.finishing = false;
        }
    }
}
